"use strict";

import { AppDispatcher } from 'Dispatcher';
import { InlineFormConstants } from "Constants/Forms/InlineFormConstants";
export function inlineFormShowTable(show) {
  AppDispatcher.dispatch({
    actionType: InlineFormConstants.INLINE_FORM_SHOW_TABLE,
    show: show
  });
}